export const SIGN_IN_DRAWER_ID = 'sign-in-drawer';

// Email format pattern for RHF-native `register('email', { pattern })`.
// `<input type="email">` already does basic browser validation; this is
// belt-and-braces for programmatic/paste input. Same pattern used by the
// Reset Password drawer's `EMAIL_PATTERN`.
export const EMAIL_PATTERN = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
